import 'date-fns';
import React from 'react';

// @mui/icons-material
// @mui/material components
import {GridItem} from '../../../../components/Grid';
import Button from '../../../../components/CustomButtons/Button';
import Grid from '@mui/material/Grid';
import {ArrayBasedMenuItem} from "../panelSegments/components";
import customSelectStyle from "../../../../assets/jss/customSelectStyle";
import {makeStyles} from "@mui/styles";
import NameBasedMenuItem from "../panelSegments/components/NameBasedMenuItem";
import {Accordion, AccordionDetails, AccordionSummary, Typography} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {SearchPanel} from "../index";

const useStyles = makeStyles((theme) => {
  return {
    button: {
      margin: theme.spacing(2),
      marginTop: 0
    },
    ...customSelectStyle
  }
})

const AccordionCard = props => {
  const {
    role,
    title,
    expanded,
    setExpanded,
    initialSections,
    sectionSelect,
    onHandleSectionSelect,
    renderSection = true,
    includeAllSections = true,
    searchSectionsByMethod = NameBasedMenuItem,
    initialClassifications,
    classificationSelect,
    renderClassification = true,
    onHandleClassificationSelect,
    includeAllClassifications = true,
    searchClassificationsByMethod = NameBasedMenuItem,
    initialCategories,
    categorySelect,
    renderCategory = true,
    onHandleCategorySelect,
    includeAllCategories = true,
    searchCategoriesByMethod = NameBasedMenuItem,
    initialCompanies,
    renderCompany = true,
    companySelect,
    onHandleCompanySelect,
    includeAllCompanies = true,
    searchCompaniesByMethod = NameBasedMenuItem,
    initialStatus,
    statusSelect,
    renderStatus = true,
    onHandleStatusSelect,
    includeAllStatus = true,
    searchStatusByMethod = ArrayBasedMenuItem,
    beginDate,
    renderBeginDate = true,
    onHandleBeginDateSelect,
    endDate,
    renderEndDate = true,
    onHandleEndDateSelect,
    filename,
    onFilenameChange,
    renderFileName = true,
    attribute,
    onAttributeChange,
    renderAttributes = true,
    setShareable,
    shareableFlag,
    onShareableChange,
    renderShareable = false,
    browseFilter = false,
    summaryText,
    renderButton = true,
    buttonText = '',
    buttonIcon,
    onButtonClick,
    customButtons = []

  } = props;

  const classes = useStyles();

  const shareableOptionList = [
    {
      'id': '1',
      'name': 'shareable',
      'label': 'Shareable'
    }]

  const allButtonElements = [];
  if (renderButton) allButtonElements.push(
    <Button
      color="primary"
      className={classes.button}
      component="span"
      variant="contained"
      onClick={onButtonClick}
    >
      {buttonIcon ? React.createElement(buttonIcon) : undefined} {buttonText}
    </Button>);
  if (customButtons) customButtons.forEach(button => allButtonElements.push(button));

  const buttonGridItems = [];
  allButtonElements.forEach((button, index) => buttonGridItems.push(<GridItem
    key={index}
    xs={12}
    md={2}
  >
    {button}
  </GridItem>));

  return (
    <Grid container>
      <Grid
        item
        xs={12}
      >
        <Grid container>
          <Accordion
              expanded={expanded}
              onChange={() => {
                setExpanded(!expanded);
              }}
              style={{width: '100%', margin: 0, padding: 10, backgroundColor: '#3b5998'}}
          >
            <AccordionSummary
                aria-controls="search-details"
                expandIcon={<ExpandMoreIcon style={{color: '#FFFFFF'}}/>}
                id="search-details"
            >
              {(browseFilter === true) ? (
                <Typography
                    style={{color: '#FFFFFF'}}
                    variant={'h3'}>Browse for {summaryText.join(", ")}
                </Typography>
              ) : (
                <Typography
                    style={{color: '#FFFFFF'}}
                    variant={'h3'}
                >{summaryText}</Typography>
              )}

            </AccordionSummary>
            <AccordionDetails style={{backgroundColor: '#FFFFFF'}}>
              <SearchPanel
                  classes={classes}
                  title={title}
                  company={companySelect}
                  role={role}

                  initialSections={initialSections}
                  initialCompanies={initialCompanies}
                  initialCategories={initialCategories}
                  initialClassifications={initialClassifications}
                  initialStatus={initialStatus}

                  sectionSelect={sectionSelect}
                  companySelect={companySelect}
                  categorySelect={categorySelect}
                  classificationSelect={classificationSelect}
                  statusSelect={statusSelect}

                  beginDate={beginDate}
                  filename={filename}
                  endDate={endDate}
                  attribute={attribute}
                  shareableFlag={shareableFlag}
                  shareableFlagOptions={shareableOptionList}

                  onHandleSectionSelect={onHandleSectionSelect}
                  onHandleCompanySelect={onHandleCompanySelect}
                  onHandleCategorySelect={onHandleCategorySelect}
                  onHandleClassificationSelect={onHandleClassificationSelect}
                  onHandleStatusSelect={onHandleStatusSelect}
                  onHandleBeginDateSelect={onHandleBeginDateSelect}
                  onHandleEndDateSelect={onHandleEndDateSelect}
                  onFilenameChange={onFilenameChange}
                  onAttributeChange={onAttributeChange}
                  onShareableChange={onShareableChange}

                  renderCategory={renderCategory}
                  renderStatus={renderStatus}
                  renderCompany={renderCompany}
                  renderClassification={renderClassification}
                  renderSection={renderSection}
                  renderBeginDate={renderBeginDate}
                  renderEndDate={renderEndDate}
                  renderFileName={renderFileName}
                  renderAttributes={renderAttributes}
                  renderShareable={renderShareable}

                  searchSectionsByMethod={searchSectionsByMethod}
                  searchCompaniesByMethod={searchCompaniesByMethod}
                  searchClassificationsByMethod={searchClassificationsByMethod}
                  searchCategoriesByMethod={searchCategoriesByMethod}
                  searchStatusByMethod={searchStatusByMethod}

                  includeAllSections={includeAllSections}
                  includeAllCompanies={includeAllCompanies}
                  includeAllClassifications={includeAllClassifications}
                  includeAllCategories={includeAllCategories}
                  includeAllStatus={includeAllStatus}

                  buttonText={buttonText}
                  buttonIcon={buttonIcon}
                  onButtonClick={onButtonClick}

                  renderButton={renderButton}
                  customButtons={customButtons}
              />
            </AccordionDetails>
          </Accordion>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default AccordionCard;
